module.exports = __webpack_public_path__ + "img/device.64428403.svg";